// Types of Actions for Auth
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const LOGOUT_SESSION = 'LOGOUT_SESSION';